import { toDeviationSegment, type DeviationSegment } from "@common/components/review/DeviationScoreBar";

function isOnlyMatchFilter(matchFilter: string[], value: string): boolean {
  return matchFilter.length === 1 && matchFilter[0] === value;
}

export function activeDeviationSegment(
  matchFilter: string[],
  importanceFilter: string[],
): DeviationSegment | null {
  if (isOnlyMatchFilter(matchFilter, "unmatched") && importanceFilter.length === 0) {
    return "compliant";
  }
  if (isOnlyMatchFilter(matchFilter, "matched") && importanceFilter.length === 1) {
    return toDeviationSegment(importanceFilter[0]);
  }
  return null;
}
